const RoleEnum = {
  ADMIN     : 'ADMIN',
  CFO       : 'CFO',
  TREASURER : 'TREASURER',
  GROUPCFO  : 'GROUP_CFO',
  SUPERADMIN: 'SUPER_ADMIN'
}

export default RoleEnum
